import { CSSProperties } from 'react';
import { ThemeColorPalette, ThemeColors } from '../../theme';
import { useThemeColorPaletteVar } from '../use-theme-color-palette-var';

export const useThemeColorPaletteAsCssTokens = (
  tokenPrefix: string,
  palette: ThemeColors,
  facets?: (keyof ThemeColorPalette)[]
): CSSProperties => {
  const colors = useThemeColorPaletteVar(palette);

  if (facets) {
    return facets.reduce((acc, facet) => {
      acc[`${tokenPrefix}--color--${facet}`] = colors[facet] as string;
      return acc;
    }, {} as Record<string, string>);
  }

  return {
    [`${tokenPrefix}--color--main`]: colors.main,
    [`${tokenPrefix}--color--dark`]: colors.dark,
    [`${tokenPrefix}--color--ultra-dark`]: colors['ultra-dark'],
    [`${tokenPrefix}--color--contrast`]: colors.contrast,
    [`${tokenPrefix}--color--light`]: colors.light,
    [`${tokenPrefix}--color--ultra-light`]: colors['ultra-light'],
  };
};
